export enum PlatformPolicyType {
    TERMS_OF_SERVICE = 'terms_of_service',
    COOKIE_POLICY = 'cookie_policy',
}

export enum PlatformWebhookAction {
    ORDER_CREATED = 'order.created',
    ORDER_UPDATED = 'order.updated',
    ORDER_DELETED = 'order.deleted',
    ORDER_FORCE_DELETED = 'order.force-deleted',

    NATURAL_PROFILE_CREATED = 'natural-profile.created',
    NATURAL_PROFILE_UPDATED = 'natural-profile.updated',
    NATURAL_PROFILE_DELETED = 'natural-profile.deleted',
    NATURAL_PROFILE_FORCE_DELETED = 'natural-profile.force-deleted',

    LEGAL_PROFILE_CREATED = 'legal-profile.created',
    LEGAL_PROFILE_UPDATED = 'legal-profile.updated',
    LEGAL_PROFILE_DELETED = 'legal-profile.deleted',
    LEGAL_PROFILE_FORCE_DELETED = 'legal-profile.force-deleted',

    ASSET_CREATED = 'asset.created',
    ASSET_UPDATED = 'asset.updated',
    ASSET_DELETED = 'asset.deleted',
    ASSET_FORCE_DELETED = 'asset.force-deleted',

    ASSET_DOCUMENT_CREATED = 'asset-document.created',
    ASSET_DOCUMENT_UPDATED = 'asset-document.updated',
    ASSET_DOCUMENT_DELETED = 'asset-document.deleted',
    ASSET_DOCUMENT_FORCE_DELETED = 'asset-document.force-deleted',

    CAMPAIGN_CREATED = 'campaign.created',
    CAMPAIGN_UPDATED = 'campaign.updated',
    CAMPAIGN_DELETED = 'campaign.deleted',
    CAMPAIGN_FORCE_DELETED = 'campaign.force-deleted',

    ISSUER_CREATED = 'issuer.created',
    ISSUER_UPDATED = 'issuer.updated',
    ISSUER_DELETED = 'issuer.deleted',
    ISSUER_FORCE_DELETED = 'issuer.force-deleted',

    EMAIL_CREATED = 'email.created',

    TRANSACTION_CREATED = 'transaction.created',
    TRANSACTION_UPDATED = 'transaction.updated',
    TRANSACTION_DELETED = 'transaction.deleted',
    TRANSACTION_FORCE_DELETED = 'transaction.force-deleted',

    CONTRACT_CREATED = 'contract.created',
    CONTRACT_UPDATED = 'contract.updated',
    CONTRACT_DELETED = 'contract.deleted',
    CONTRACT_FORCE_DELETED = 'contract.force-deleted',

    USER_TRACKING_EVENT_CREATED = 'user-tracking-event.created',

    EXPORT_TASK_FINISHED = 'export-task.finished',

    BASKET_CREATED = 'basket.created',
    BASKET_UPDATED = 'basket.updated',
    BASKET_DELETED = 'basket.deleted',
    BASKET_FORCE_DELETED = 'basket.force-deleted',

    KYC_DOCUMENT_CREATED = 'kyc-document.created',
    KYC_DOCUMENT_UPDATED = 'kyc-document.updated',
    KYC_DOCUMENT_DELETED = 'kyc-document.deleted',
    KYC_DOCUMENT_FORCE_DELETED = 'kyc-document.force-deleted',

    INTEREST_PAYMENT_CREATED = 'interest-payment.created',

    MONEY_WITHDRAWAL_CREATED = 'money-withdrawal.created',
    MONEY_WITHDRAWAL_UPDATED = 'money-withdrawal.updated',
    MONEY_WITHDRAWAL_DELETED = 'money-withdrawal.deleted',
    MONEY_WITHDRAWAL_FORCE_DELETED = 'money-withdrawal.force-deleted',

    WALLET_CREATED = 'wallet.created',
    WALLET_UPDATED = 'wallet.updated',
    WALLET_DELETED = 'wallet.deleted',
    WALLET_FORCE_DELETED = 'wallet.force-deleted',

    ORDER_DOCUMENT_CREATED = 'order-document.created',
    ORDER_DOCUMENT_UPDATED = 'order-document.updated',
    ORDER_DOCUMENT_DELETED = 'order-document.deleted',
    ORDER_DOCUMENT_FORCE_DELETED = 'order-document.force-deleted',

    BANK_ACCOUNT_CREATED = 'bank-account.created',
    BANK_ACCOUNT_UPDATED = 'bank-account.updated',
    BANK_ACCOUNT_DELETED = 'bank-account.deleted',
    BANK_ACCOUNT_FORCE_DELETED = 'bank-account.force-deleted',

    EXTERNAL_KYC_PROCESS_CREATED = 'external-kyc-process.created',
    EXTERNAL_KYC_PROCESS_UPDATED = 'external-kyc-process.updated',
    EXTERNAL_KYC_PROCESS_DELETED = 'external-kyc-process.deleted',
    EXTERNAL_KYC_PROCESS_FORCE_DELETED = 'external-kyc-process.force-deleted',
}

export enum KycProvider {
    SIGNTEQ = 'signteq',
    IDNOW = 'idnow',
}

export enum UserFeedbackProvider {
    PUSHFEEDBACK = 'pushfeedback',
    USERSNAP = 'usersnap',
}

export enum KycFieldRestrictionMode {
    SIMPLE_FIELD_RESTRICTION = 'simple_field_restriction',
}

export enum PlatformMembershipType {
    MANUAL = 'manual',
    SPROOF = 'sproof',
}

export const PlatformEmailTemplates: Array<string> = [
    'mail_active_welcome',
    'mail_active_acceptance_notice',
    'mail_active_bank_account_information_reminder',
    'mail_active_basket_reminder',
    'mail_active_consumer_information',
    'mail_active_gift_consumer_information',
    'mail_active_external_kyc_status_pending',
    'mail_active_external_kyc_status_success',
    'mail_active_external_kyc_process_aborted',
    'mail_active_kyc_expire_reminder',
    'mail_active_interest_payment_announcement',
    'mail_active_interest_payment_payout_received',
    'mail_active_kyc_reminder',
    'mail_active_kyc_status',
    'mail_active_no_iban_reminder',
    'mail_active_payment_confirmation',
    'mail_active_payment_details',
    'mail_active_payment_reminder',
    'mail_active_pre_consumer_information',
    'mail_active_signature_reminder',
    'mail_active_signature_successful',
    'mail_active_signatures_regenerated',
    'mail_active_voucher_received',
    'mail_active_feedback_review',
    'mail_active_wallet_balance',
    'mail_active_voucher_balance',
    'mail_active_membership_document_reminder',
]

export enum PlatformEmailTemplateType {
    CONSUMER_INFORMATION = 'consumer_information',
    GIFT_CONSUMER_INFORMATION = 'gift_consumer_information',
    PAYMENT_DETAILS = 'payment_details',
    SAVINGS_PLAN_PAYMENT_REMINDER = 'savings_plan_payment_reminder',
    PAYMENT_REMINDER = 'payment_reminder',
    WELCOME = 'welcome',
    MEMBERSHIP_DOCUMENT_ACCEPTED = 'membership_document_accepted',
    PAYMENT_CONFIRMATION = 'payment_confirmation',
    ACCEPTANCE_NOTICE = 'acceptance_notice',
    KYC_REMINDER = 'kyc_reminder',
    KYC_STATUS = 'kyc_status',
    KYC_EXPIRE_REMINDER = 'kyc_expire_reminder',
    BASKET_REMINDER_ONE = 'basket_reminder_one',
    BASKET_REMINDER_TWO = 'basket_reminder_two',
    SIGNATURE_REMINDER = 'signature_reminder',
    SIGNATURES_REGENERATED = 'signatures_regenerated',
    SIGNATURE_SUCCESSFUL = 'signature_successful',
    BANK_ACCOUNT_INFORMATION_REMINDER = 'bank_account_information_reminder',
    PRE_CONSUMER_INFORMATION = 'pre_consumer_information',
    EXTERNAL_KYC_STATUS_PENDING = 'external_kyc_status_pending',
    EXTERNAL_KYC_STATUS_SUCCESS = 'external_kyc_status_success',
    NO_IBAN_REMINDER = 'no_iban_reminder',
    MONEY_WITHDRAWAL_VERIFICATION = 'money_withdrawal_verification',
    VOUCHER_RECEIVED = 'voucher_received',
    FEEDBACK_REVIEW = 'feedback_review',
    CORPORATE_ACCOUNT_CREATED = 'corporate_account_created',
    CORPORATE_DOCUMENTS_SUBMITTED = 'corporate_documents_submitted',
    ORDER_CANCELLED = 'order_cancelled',
    ORDER_CANCELLED_INVESTOR_CONFIRMATION = 'order_cancelled_investor_confirmation',
}

export enum PlatformComplianceProfile {
    ESAC = 'esac',
    ECSP = 'ecsp',
}

export enum FundingTotalStatus {
    PENDING = 0,
    PAID = 1,
    ACCEPTED = 2,
}

export enum CancelCounterStart {
    CREATED_AT = 'created_at',
    PAID_AT = 'paid_at',
    ACCEPTED_AT = 'accepted_at',
}
